import { jsonldDescription } from './JsonldStore';

export const updateJsonldDescription = (value) => jsonldDescription.update((oldValue) => value);
